import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';
// template components
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';
import WidowBlock from '@nmx/template/dist/componentLibrary/components/WidowBlock';
// images
import experienceCalloutJpg from  './images/smiling-office-worker-desktop.webp';
// styles import
import { ExperienceCalloutStyled } from './styles';

export default () => {
  const theme = useContext(ThemeContext);
  const isLargeUp = theme.largeUp();

  const desktopHeading = () => (
    <>
      <Typography
        themeType='darkTheme'
        component='span'
        block
        disableBottomPadding>
        Want to feel financially confident&#63;
      </Typography>
      <Typography
        themeType='darkTheme'
        component='span'
        block
        disableBottomPadding>
        An advisor can help.
      </Typography>
    </>
  );

  const mobileHeading = () => (
    <>
      Want to feel financially confident&#63; An advisor <WidowBlock>can help.</WidowBlock>
    </>
  );

  return (
    <ExperienceCalloutStyled
      // config props
      sectionId='financial-advisor-experience-callout'
      moduleName='experience-callout-module'
      moduleVariation='A'
      backgroundVariant='darkDefault'
      calloutBackgroundVariant='darkDefault'
      calloutThemeType='darkTheme'
      themeType='darkTheme'
      // content props
      headingText={isLargeUp ? desktopHeading() : mobileHeading()}
      descriptionText='We bust the biggest myths about working with one.'
      buttonText='Read the article'
      imageUrl={experienceCalloutJpg.toString()}
      linkUrl='https://www.northwesternmutual.com/life-and-money/the-trick-to-boost-your-financial-confidence/'
      // misc props
      isFullWidth
      withBGImage
      disableLazyLoad
      withHoverShadow={false}
    />
  );
};
